(function () {
  'use strict';
  function initBikeMenu() {
    var button = document.querySelector('header button[aria-haspopup="menu"]');
    if (!button || button.dataset.bikesReady) return;
    button.dataset.bikesReady = 'true';
    button.classList.add('sumo-bike-trigger');
    button.setAttribute('aria-controls', 'sumoBikeMenu');
    var menu = document.createElement('div');
    menu.id = 'sumoBikeMenu';
    menu.className = 'sumo-bike-menu';
    menu.setAttribute('role', 'menu');
    menu.setAttribute('aria-label', 'Shop by bike');
    menu.hidden = true;
    var seen = new Set();
    document.querySelectorAll('header [data-sumo-bike-link]').forEach(function (source) {
      var label = source.textContent.trim();
      if (seen.has(label)) return;
      seen.add(label);
      var link = document.createElement('a');
      link.href = source.href;
      link.textContent = label;
      link.setAttribute('role', 'menuitem');
      link.tabIndex = -1;
      menu.appendChild(link);
    });
    var order = ["Tuttio Soleil 01", "Yozma IN10 / IN10 Pro", "Strike Shadow 60V/72V", "Heybike Villain", "Talaria", "Surron LBX", "E Ride", "Ultra Bee", "RTR"];
    Array.from(menu.children).sort(function (a, b) { return order.indexOf(a.textContent) - order.indexOf(b.textContent); }).forEach(function (link) { menu.appendChild(link); });
    document.body.appendChild(menu);
    function position() {
      var rect = button.getBoundingClientRect();
      menu.style.left = Math.max(12, Math.min(rect.left, innerWidth - menu.offsetWidth - 12)) + 'px';
      menu.style.top = (rect.bottom + 7) + 'px';
      menu.style.maxHeight = Math.max(100, innerHeight - rect.bottom - 24) + 'px';
    }
    function close(restoreFocus) {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (restoreFocus) button.focus();
    }
    function open(focusLast, keyboard) {
      menu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      position();
      var links = menu.querySelectorAll('a');
      if (keyboard && links.length) links[focusLast ? links.length - 1 : 0].focus();
    }
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (menu.hidden) open(false, false); else close(true);
    });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open(event.key === 'ArrowUp', true);
      }
    });
    menu.addEventListener('keydown', function (event) {
      var links = Array.from(menu.querySelectorAll('a'));
      var index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        links[event.key === 'Home' ? 0 : links.length - 1].focus();
      } else if (event.key === 'Tab') close(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) close(true);
    });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !menu.contains(event.target) && !button.contains(event.target)) close(false);
    });
    window.addEventListener('resize', function () { if (!menu.hidden) position(); });
    window.addEventListener('scroll', function () { if (!menu.hidden) position(); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBikeMenu);
  else initBikeMenu();
  document.addEventListener('shopify:section:load', function () {
    var existing = document.getElementById('sumoBikeMenu');
    if (existing) existing.remove();
    var button = document.querySelector('header button[aria-haspopup="menu"]');
    if (button) delete button.dataset.bikesReady;
    initBikeMenu();
  });
})();
